export default __webpack_public_path__ + "static/tv-show-10-2872cb05f736071f7228f20869a3d702.jpg";